import { useLang } from 'hooks/lang';

import { ProjectService, calculateProjectTotal } from 'entities';

import { Card, Row } from 'components/Blocks';
import { PercentageVariation } from 'components/PercentageVariation';

import { RepriceService, mergeServices } from './utils';
import { formatCurrency } from 'utils/text';
import { getPercentageDifference } from 'utils/percentage';

interface PriceChangeProps {
  children?: never;
  currentServices: ProjectService[];
  repricedServices: RepriceService[];
  currency: string;
}

export function getPriceDeltaPercentage(
  currentServices: ProjectService[],
  repricedServices: RepriceService[],
) {
  const [currentTotal, newTotal] = [
    currentServices,
    mergeServices(repricedServices, currentServices),
  ].map(calculateProjectTotal);

  return {
    currentTotal,
    newTotal,
    delta: getPercentageDifference(currentTotal, newTotal),
  };
}

export function PriceChange({ currentServices, repricedServices, currency }: PriceChangeProps) {
  const { t } = useLang();

  const { currentTotal, newTotal } = getPriceDeltaPercentage(currentServices, repricedServices);

  return (
    <Card flow="column">
      <Row justifyContent="space-between">
        <span>{t('project-total-before')}</span>

        <span className="font-semibold">{formatCurrency(currentTotal, currency)}</span>
      </Row>

      <Row justifyContent="space-between">
        <span>{t('project-total-after')}</span>

        <Row>
          <PercentageVariation current={currentTotal} newValue={newTotal} />

          <span className="font-semibold">{formatCurrency(newTotal, currency)}</span>
        </Row>
      </Row>
    </Card>
  );
}
